








var ReactPropTypeLocationNames={};

if(process.env.NODE_ENV!=='production'){
ReactPropTypeLocationNames={
prop:'prop',
context:'context',
childContext:'child context'};

}

module.exports=ReactPropTypeLocationNames;


// WEBPACK FOOTER //
// ./~/react-native-web/dist/vendor/ReactPropTypeLocationNames/index.js